/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { IMacro, IMacroAction, IMacroTipo, IMacroViagem } from 'Models/docas'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'

const macro = {
  getList: async (idComponente: number, cdArmazem?: number) => {
    const result: AxiosResponse<ServiceListResponse<IMacro>> = await ApiService(
      { idComponente },
    ).get<ServiceListResponse<IMacro>>(
      QueryStringFilter(`${hosts.WS_DOCAS}/macro`, { cdArmazem }),
    )

    return result
  },

  executaMacro: async (idComponente: number, data: IMacroAction) => {
    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).post<ServiceListResponse>(`${hosts.WS_DOCAS}/macro`, data)

    return result
  },

  buscaMacrosEmitidas: async (idComponente: number, cdCandidato: number) => {
    const result: AxiosResponse<ServiceListResponse<IMacro>> = await ApiService(
      { idComponente },
    ).get<ServiceListResponse<IMacro>>(`${hosts.WS_DOCAS}/macro/${cdCandidato}`)

    return result
  },

  getTiposMacro: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<IMacroTipo>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IMacroTipo>>(
        `${hosts.WS_DOCAS}/macro_tipo`,
      )

    return result
  },

  getTiposMacroViagem: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<IMacroTipo>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IMacroTipo>>(
        `${hosts.WS_DOCAS}/tipos_macro_viagem`,
      )

    return result
  },

  getTiposMacroViagemPesquisa: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<IMacroTipo>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IMacroTipo>>(
        `${hosts.WS_DOCAS}/tipos_macro_viagem_pesquisa`,
      )

    return result
  },

  buscaRegistrosMacroViagem: async (
    idComponente: number,
    chavePesquisa: string,
    valorPesquisa: string,
  ) => {
    const body = {
      tipoIdentificador: chavePesquisa,
      identificador: valorPesquisa,
    }

    const result: AxiosResponse<ServiceListResponse<IMacroViagem>> =
      await ApiService({
        idComponente,
      }).post<ServiceListResponse>(
        `${hosts.WS_DOCAS}/busca_registros_macro_viagem`,
        body,
      )

    return result
  },

  registraMacroViagem: async (
    idComponente: number,
    macroViagem: IMacroViagem,
  ) => {
    const body = {
      dtAcao: macroViagem.dtAcao,
      cdViagem: macroViagem.cdViagem,
      cdMacro: macroViagem.cdMacro,
      cdUsuario: macroViagem.cdUsuario,
      justificativa: macroViagem.justificativa,
    }

    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).post<ServiceListResponse>(
      `${hosts.WS_DOCAS}/registra_macro_viagem`,
      body,
    )

    return result
  },
}

export default macro
